import {
  combineTranslationBundles,
  type TranslationModule
} from '@hconnect/common/localization-loaders'

export const FEATURE_NAMESPACE = 'feature.stoppage-list'

const stoppageListTranslationModule: TranslationModule = {
  namespace: FEATURE_NAMESPACE,
  resources: {
    de: () => import('./de_DE.json'),
    'en-GB': () => import('./en_US.json'),
    'en-US': () => import('./en_US.json'),
    'fr-FR': () => import('./fr.json'),
    'it-IT': () => import('./it.json'),
    'hu-HU': () => import('./hu.json'),
    'ru-RU': () => import('./ru.json')
  }
}

const externalPackageTranslations: TranslationModule[] = []

export const stoppageListFeatureTranslations = combineTranslationBundles([
  externalPackageTranslations,
  stoppageListTranslationModule
])
